<template>
  <footer>
    <div class="container">
      <p>
        Built by
        <a
          href="https://twitter.com/smdly"
          rel="noopener nofollow"
          target="_blank"
          >@smdly</a
        >. View on
        <a
          href="https://github.com/michaelsmedley/runlist/"
          rel="noopener nofollow"
          target="_blank"
          >Github</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
footer {
  @apply bg-black-500 text-white-500 text-center py-5;

  p {
    @apply m-0 p-0;
  }
}
</style>
